"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecaptcha = useRecaptcha;
var _useScript = _interopRequireDefault(require("../useScript"));
var _react = require("react");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function useRecaptcha(siteKey, action, onToken) {
  var _a = (0, _react.useState)({
      execute: null,
      isLoading: true
    }),
    state = _a[0],
    setState = _a[1];
  (0, _useScript.default)({
    src: "https://www.google.com/recaptcha/api.js?render=" + siteKey,
    loadCondition: function loadCondition() {
      return !window.grecaptcha;
    },
    onload: function onload() {
      window.grecaptcha.ready(function () {
        var newExecute = function newExecute() {
          window.grecaptcha.execute(siteKey, {
            action: action
          }).then(function (token) {
            onToken(token);
          });
        };
        setState({
          execute: newExecute,
          isLoading: false
        });
      });
    }
  });
  return state;
}